"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_defined_1 = require("./is-defined");
function getShortcut(string, toUpperCase = false) {
    if (!(0, is_defined_1.isValue)(string))
        return '';
    const shortcut = string
        .split(/\s/)
        .reduce((response, word) => (response += word.slice(0, 1)), '');
    if (toUpperCase) {
        return shortcut.toUpperCase();
    }
    return shortcut;
}
function getCapitalizeWord(string) {
    if (!(0, is_defined_1.isValue)(string))
        return '';
    return string[0].toUpperCase() + string.substring(1);
}
exports.default = { getShortcut, getCapitalizeWord };
